import IApiError from "@/app/model/IApiError";
import ProcessResultKey from "@/app/dto/ProcessResultKeyEnum";
import ICreateKeyResponse from "@/app/dto/ICreateKeyResponse";
import IKeyFactorData from "@/app/dto/IKeyFactorData";
import Factor from "@/app/dto/FactorEnum";
import OtpResult from "@/app/model/OtpResult";

export default class KeyResult {
    authKey?: string;
    error?: IApiError;
    otpKey?: string;
    phoneNumber?: string;
    waitUntil?: string;

    constructor(data?: ICreateKeyResponse, error?: IApiError) {
        this.authKey = data?.key;
        this.error = error;
        const otp = data?.factors?.find((f: IKeyFactorData) => f.type == Factor.OTP)?.otp;
        this.otpKey = otp?.key
        this.phoneNumber = otp?.phoneNumber
        this.waitUntil = otp?.waitUntil
    }

    public getAuthorizationKey(): string | undefined {
        return this.authKey;
    }

    public getPhoneNumber(): string | undefined {
        return this.phoneNumber;
    }

    public getWaitUntil(): Date | undefined {
        const waitUntil: string | undefined =
            this.waitUntil || this.getErrorDataAuthorization()?.waitUntil || this.getErrorDataAuthorization()?.blockedUntil;
        return waitUntil ? new Date(waitUntil) : undefined;
    }

    public getOtpKey(): string | undefined {
        return this.otpKey;
    }

    public isAuthorizationBlocked(): boolean {
        return this.error?.status == ProcessResultKey.AUTHORIZATION_BLOCKED;
    }

    public isNotReadyYet(): boolean {
        return this.error?.status == ProcessResultKey.OTP_NOT_READY_YET;
    }

    public isLimitReached(): boolean {
        return this.error?.status == ProcessResultKey.OTP_LIMIT_REACHED;
    }

    public isPhoneBlocked(): boolean {
        return this.error?.status == ProcessResultKey.OTP_PHONE_BLOCKED;
    }

    public isVerifiedMobileNotFound(): boolean {
        return this.error?.status == ProcessResultKey.VERIFIED_MOBILE_NOT_FOUND;
    }

    public mergeKey(keyResult: KeyResult): void {
        this.authKey = keyResult.authKey;
        this.error = keyResult.error;
        if (keyResult.otpKey) {
            this.otpKey = keyResult.otpKey
        }
        if (keyResult.phoneNumber) {
            this.phoneNumber = keyResult.phoneNumber
        }
        if (keyResult.waitUntil) {
            this.waitUntil = keyResult.waitUntil
        }
    }

    public mergeOtp(otpResult: OtpResult): void {
        if (otpResult.data) {
            this.otpKey = otpResult.data.key;
            this.phoneNumber = otpResult.data.phoneNumber;
            this.waitUntil = otpResult.data.waitUntil;
        }
        if (otpResult.error) {
            this.waitUntil = undefined
            this.error = otpResult.error;
        }
    }

    private getErrorDataAuthorization(): { waitUntil?: string; blockedUntil?: string } | undefined {
        return this.error?.communicationError.data?.authorization;
    }

}
